module.exports = __webpack_public_path__ + "media/src/images/purchase_voucher_header-8504a1f6f6ff934ce7a8575821fe7bc4.jpg";